export default __webpack_public_path__ + "static/torii-1-851f97fc3f8f55c8f1928d76d00fb695.jpg";